import {CargoType} from "../transportation/models/cargo";

export function isDangerousGood(cargoType: CargoType | "") {
    switch(cargoType) {
        case CargoType.DANGEROUS_TRAILER:
        case CargoType.DANGEROUS_CONTAINER:
        case CargoType.DANGEROUS_GENERAL_CARGO:
        case CargoType.DANGEROUS_LORRY:
            return true;
        default: return false;
    }
}